<template>
  <div class="Disabled">
    <Navbar />
    <div class="disabled-details">
      <h4>Oops!</h4>
      <SVGDisabledView/>
      <p>Seems like your Wowzi account has been suspended.</p>
      <w-button type="submit" @click="contact()" class="button--large">
        <a>contact support</a>
      </w-button>
    </div>
  </div>
</template>

<script>
  import SVGDisabledView from '../../assets/img/disabled-view.svg';

  export default {
    name: 'Disabled',
    components: {
      SVGDisabledView,
    },
    methods: {
      contact() {
        window.open('https://mail.google.com/mail/?view=cm&fs=1&to=support@wowzi.co', '_blank');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/variables";
  .Disabled {
    .disabled-details {
      margin: 24px 0 0;
      position: relative;
      top: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      h4 {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 44px;
        color: #02CAF2;
        margin-bottom: 25px;
      }
      p {
        width: 288px;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #1A1A1D;
        text-align: center;
        margin: 40px 0 24px;
      }
      .button--large {
        margin-bottom: 32px;
        width: 200px !important;
        height: 56px;
        a {
          width: 100%;
          height: 100%;
          display: block;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>
